<template>
    <div class="input-group custom-input-group">
        <div class="search-input-wrapper">
            <input type="text" 
                   v-model="searchQuery" 
                   class="form-control dropdown-toggle"
                   id="dropdownMenuButton3" 
                   data-bs-toggle="dropdown"
                   role="combobox"
                   aria-autocomplete="list"
                   aria-expanded="false"
                   aria-controls="custom-dropdown-menu"
                   aria-label="Search Business Category"
                   placeholder="Search Business Category"
                   autocomplete="off">

            <ul id="custom-dropdown-menu" 
                class="dropdown-menu custom-dropdown-menu sraech"
                role="listbox">
                <li v-for="item in displayedItems" 
                    :key="item.slug"
                    role="option">
                    <a class="dropdown-item" @click="selectSubcategory(item)">
                        <i class="fa fa-list-alt mr-1" aria-hidden="true"></i>{{ item.name }}
                    </a>
                </li>
                <li v-if="displayedItems.length === 0" role="presentation">
                    <img width="100%" height="180" 
                         src="/svg/searching-data.svg" 
                         alt="Illustration encouraging users to search for a business type">
                    <p class="text-center">Search Any Business Type</p>
                </li>
            </ul>
        </div>

        <div class="location-input-wrapper">
            <input type="text" 
                   v-model="country_name" 
                   class="form-control dropdown-toggle"
                   id="dropdownMenuButton4" 
                   data-bs-toggle="dropdown"
                   role="combobox"
                   aria-autocomplete="list"
                   aria-expanded="false"
                   aria-controls="custom-dropdown-menu2"
                   :placeholder="`${location.city}, ${location.country_name}`"
                   :aria-label="`Select location — currently ${location.city}, ${location.country_name}`"
                   autocomplete="off">

            <ul id="custom-dropdown-menu2" 
                class="dropdown-menu custom-dropdown-menu1"
                role="listbox">
                <li v-for="location in filteredCountries" 
                    :key="location.id"
                    role="option">
                    <button class="dropdown-item" 
                            type="button"
                            @click="handleLocationSelection(location.name, location.id, location.slug)">
                        <i class="fas fa-map-marker-alt mr-1" aria-hidden="true"></i>{{ location.name }}
                    </button>
                </li>
            </ul>
        </div>

        <button class="btn btn-primary" 
                aria-label="Search Businesses" 
                type="button" 
                @click="navigateToSubcategory" 
                style="margin-top: 10px;">
            <i class="fa fa-search" aria-hidden="true"></i>
        </button>
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';

export default {
    name: "Login",
    data() {
        return {
            country_name: '',
            searchQuery: '',
            selectedSubcategory: null,
            country_slug: '',
        };
    },

    computed: {
        ...mapState('business', ['cartItems']),
        ...mapState('auth', ['isAuthenticated', 'token', 'user']),
        ...mapState('home', ['categories', 'category_loading', 'subcategories', 'location', 'country_name', 'country_id']),
        ...mapState('dashboard', ['totalDashboardOrder']),
        filteredCountries() {
            return this.location.all_countries.filter(country =>
                country.name.toLowerCase().includes(this.country_name.toLowerCase())
            );
        },
        selectedCategories() {
            const selectedIds = [8, 10, 15, 6];
            return this.categories.filter(category => selectedIds.includes(category.id));
        },
        displayedItems() {
            if (this.searchQuery) {
                return this.subcategories.filter(item =>
                    item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                );
            } else {
                return this.subcategories.slice(0, 0);
            }
        }
    },
    
    methods: {
        ...mapActions('auth', ['getUser', 'logout']),
        ...mapActions('business', ['fetchCartItems']),
        ...mapActions('home', ['fetchCategories', 'getLocation', 'setLocation']),
        
        logoutUser() {
            this.logout();
            this.$router.push({name: 'home'});
        },
        
        selectSubcategory(subcategory) {
            this.selectedSubcategory = subcategory;
            this.searchQuery = subcategory.name;
        },
        
        async handleLocationSelection(country_name, country_id, country_slug) {
            await this.setLocation({country_name, country_id});
            this.country_name = country_name;
            this.country_slug = country_slug;
        },
        
        navigateToSubcategory() {
            if (this.selectedSubcategory && this.country_name) {
                this.$router.push({
                    name: 'category',
                    params: {
                        category: this.selectedSubcategory.category_slug,
                        sub_category: this.selectedSubcategory.slug,
                        country: this.country_slug
                    }
                });
            } else {
                alert('Please select both a subcategory and a location.');
            }
        },
        
        getSubcategories(categoryId) {
            return this.subcategories.filter(subcategory => subcategory.category_id == categoryId).slice(0, 6);
        },
        
        clearSearchQuery() {
            this.searchQuery = '';
        }
    },
}
</script>

<style scoped>
/* Input wrappers */
.search-input-wrapper,
.location-input-wrapper {
    position: relative;
    width: 100%;
}

/* Custom input group */
.custom-input-group {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

/* Form controls */
.custom-input-group .form-control {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin: 0px;
    border-color: rgba(235, 235, 235, 1);
    width: 100%;
}

.custom-input-group .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}

.custom-form-input {
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 18px 0px;
    width: 100%;
}

.fa-search {
    font-size: 20px;
}

/* Dropdown 1 - Search dropdown */
.custom-dropdown-menu {
    border: none;
    border-radius: 0;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 18px 0px;
    margin-top: 0px !important;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    width: 100% !important;
}

.sraech {
    height: 17rem;
    overflow: auto;
}

.custom-dropdown-menu li {
    width: 100%;
}

.custom-dropdown-menu li a {
    display: block;
    width: 100%;
    padding: 0.75rem 1rem;
    color: #616466 !important;
    text-decoration: none;
}

/* Dropdown 2 - Location dropdown */
.custom-dropdown-menu1 {
    border: none;
    border-radius: 0;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 18px 0px;
    margin-top: 0px !important;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
    max-height: 300px;
    overflow: auto;
    cursor: pointer;
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    width: 100% !important;
}

.custom-dropdown-menu1 li {
    width: 100%;
}

.custom-dropdown-menu1 li button {
    display: block;
    width: 100%;
    padding: 0.75rem 1rem;
    color: #616466 !important;
    text-decoration: none;
    border: none;
    background: none;
    text-align: left;
}

.custom-dropdown-menu1 li button:hover {
    background-color: #f8f9fa;
}

/* Other existing styles */
.dropdown-toggle {
    width: 100% !important;
}

.main-input-plus-nav {
    display: flex !important;
    flex-direction: column !important;
    margin-top: 10px;
}

.nav-item a {
    font-size: 14px;
    font-weight: 400 !important;
    color: #515455 !important;
}

.dropdown-menu.two-column {
    width: 400px;
    columns: 2;
    padding-left: 10px !important;
}

.navbar-nav .nav-link.active, 
.navbar-nav .nav-link.show, 
.navbar-nav .nav-link:hover {
    color: var(--bs-navbar-active-color) !important;
}

.dropdown-item {
    padding: 10px;
    font-size: 14px;
}

.dropdown-item:hover {
    background-color: #f8f9fa;
}

@media only screen and (max-width: 600px) {
    .header {
        margin-top: 0 !important;
    }
}

/* No gap at all */
.custom-dropdown-menu,
.custom-dropdown-menu1 {
    margin: 0 !important;
    transform: translateY(0) !important;
}
</style>